/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosAbsencePoliciesAbsencePolicyDto,
  FacilityFlowCoreModulesPlanningDtosAbsencePoliciesUpdateAbsencePolicyRequest
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAbsencePolicy = () => {
/**
 * @summary Get the tenant's absence policy. Returns the built-in defaults when the tenant has
never saved settings.
 */
const getApiV1AbsencePolicy = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencePoliciesAbsencePolicyDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencePoliciesAbsencePolicyDto>(
      {url: `/api/v1/absence-policy`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update the tenant's absence policy.
 */
const putApiV1AbsencePolicy = (
    facilityFlowCoreModulesPlanningDtosAbsencePoliciesUpdateAbsencePolicyRequest: FacilityFlowCoreModulesPlanningDtosAbsencePoliciesUpdateAbsencePolicyRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencePoliciesAbsencePolicyDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencePoliciesAbsencePolicyDto>(
      {url: `/api/v1/absence-policy`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencePoliciesUpdateAbsencePolicyRequest
    },
      options);
    }
  return {getApiV1AbsencePolicy,putApiV1AbsencePolicy}};
export type GetApiV1AbsencePolicyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsencePolicy>['getApiV1AbsencePolicy']>>>
export type PutApiV1AbsencePolicyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsencePolicy>['putApiV1AbsencePolicy']>>>
